module.exports = __webpack_public_path__ + "static/img/yd-bg2.3198915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-bg2.jpg
// module id = dHkI
// module chunks = 0